import Vue from 'vue';

export default Vue.filter('mask', (value, regex, replace) => {
  return value ? value.replace(regex, replace) : '-';
});
